import { useSyncExternalStore } from 'react'
import {
  getWebchatRuntime,
  subscribeWebchatRuntime,
} from '../../../store/webchat-runtime'

export const useWebchatRuntime = () =>
  useSyncExternalStore(subscribeWebchatRuntime, getWebchatRuntime)
